var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showbackButton)?_c('span',{staticClass:"back-button",on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("mdi-arrow-left-circle")]),_c('span',[_vm._v("Back")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }